export default function ({ language }) {
  var config = {
    validators: ['mandatory', 'onlyDigits'],
    thousands: '',
    suffix: 'cm',
    format: 'integer',
    placeholder: '100 cm',
  };

  return {
    config,
    extendsType: 'text-field',
  };
}
